// ==================== SKILLS ====================
export const skillsData = {
  cybersecurity: [
    {
      name: "Network Security",
      level: 92,
      icon: "🛡️",
      description: "Firewalls, VPNs, IDS/IPS, network segmentation",
    },
    {
      name: "Penetration Testing",
      level: 88,
      icon: "🔍",
      description: "OWASP Top 10, vulnerability assessment, ethical hacking",
    },
    {
      name: "Cryptography",
      level: 90,
      icon: "🔐",
      description: "Encryption algorithms, PKI, digital signatures, SSL/TLS",
    },
    {
      name: "Incident Response",
      level: 88,
      icon: "🚨",
      description: "Forensics, malware analysis, recovery procedures",
    },
    {
      name: "Web Security",
      level: 94,
      icon: "🌐",
      description: "XSS, CSRF, SQL injection protection, CORS policies",
    },
  ],
  webDev: [
    {
      name: "React.js",
      level: 95,
      icon: "⚛️",
      description: "Advanced hooks, context, performance optimization",
    },
    {
      name: "JavaScript/ES6+",
      level: 98,
      icon: "⚡",
      description: "Modern JavaScript, async programming, design patterns",
    },
    {
      name: "Node.js",
      level: 88,
      icon: "🟢",
      description: "Express, REST APIs, authentication, microservices",
    },
    {
      name: "Next.js",
      level: 90,
      icon: "▲",
      description: "SSR, SSG, API routes, performance optimization",
    },
    {
      name: "Tailwind CSS",
      level: 96,
      icon: "🎨",
      description: "Utility-first CSS, responsive design, custom components",
    },
    {
      name: "Python",
      level: 85,
      icon: "🐍",
      description: "Scripting, automation, security tools, data analysis",
    },
    {
      name: "SASS",
      level: 75,
      icon: "💅",
      description: "Variables, nesting, mixins, partials, responsive design",
    },
    {
      name: "HTML",
      level: 90,
      icon: "🌐",
      description: "Semantic markup, accessibility, SEO, forms, best practices",
    },
    {
      name: "CSS",
      level: 85,
      icon: "🎨",
      description: "Flexbox, Grid, animations, transitions, responsive layouts",
    },
    {
      name: "Express.js",
      level: 70,
      icon: "⚡",
      description: "REST APIs, middleware, routing, authentication, error handling",
    },
    {
      name: "Bootstrap",
      level: 80,
      icon: "📱",
      description: "Responsive grid, components, utility classes, customization",
    },
    {
      name: "MongoDB",
      level: 85,
      icon: "🍃",
      description: "Aggregation, Indexing, Replication, Sharding",
    },
    {
      name: "PostgreSQL",
      level: 82,
      icon: "🐘",
      description: "SQL queries, Performance tuning, Transactions",
    },
  ],
  graphicDesign: [
    {
      name: "UI/UX Design",
      level: 95,
      icon: "🎨",
      description: "User research, wireframing, prototyping, usability testing",
    },
    {
      name: "Figma",
      level: 98,
      icon: "🎯",
      description: "Design systems, auto-layout, prototyping, collaboration",
    },
    {
      name: "Adobe Creative Suite",
      level: 92,
      icon: "🖌️",
      description: "Photoshop, Illustrator, XD, After Effects",
    },
    {
      name: "Motion Design",
      level: 80,
      icon: "🎬",
      description: "Animations, micro-interactions, Lottie files",
    },
    {
      name: "Color Theory",
      level: 94,
      icon: "🌈",
      description: "Color psychology, accessibility, palettes, contrast",
    },
  ],
  devOps: [
    {
      name: "Azure",
      level: 85,
      icon: "☁️",
      description: "EC2, S3, Lambda, RDS, CloudFormation",
    },
    {
      name: "Docker",
      level: 88,
      icon: "🐳",
      description: "Container orchestration, Docker Compose, Swarm",
    },
    {
      name: "Kubernetes",
      level: 75,
      icon: "⚓",
      description: "Deployments, Services, Helm charts, K8s security",
    },
    {
      name: "Terraform",
      level: 78,
      icon: "🏗️",
      description: "Infrastructure as Code, modules, state management",
    },
    {
      name: "CI/CD",
      level: 90,
      icon: "⚡",
      description: "GitHub Actions, Jenkins, GitLab CI, automation",
    },
    {
      name: "Linux/Unix",
      level: 92,
      icon: "🐧",
      description: "Shell scripting, system administration, servers",
    },
    {
      name: "Nginx",
      level: 86,
      icon: "🔧",
      description: "Reverse proxy, load balancing, SSL termination",
    },
    {
      name: "Monitoring",
      level: 83,
      icon: "📈",
      description: "Prometheus, Grafana, ELK stack, alerting",
    },
    {
      name: "Ansible",
      level: 72,
      icon: "🤖",
      description: "Configuration management, playbooks, automation",
    },
    {
      name: "Git",
      level: 95,
      icon: "📚",
      description: "Advanced workflows, hooks, rebase, bisect",
    },
    {
      name: "Python Scripting",
      level: 88,
      icon: "🐍",
      description: "Automation scripts, APIs, data processing",
    },
    {
      name: "Database Management",
      level: 84,
      icon: "🗃️",
      description: "Backups, optimization, replication, scaling",
    },
  ],
};

// ==================== CERTIFICATIONS ====================
export const certificationsData = [
  {
    title: "CompTIA Security+",
    issuer: "CompTIA",
    date: "05-2026",
    skills: ["Network Security", "Risk Management", "Cryptography"],
  },
  {
    title: "AZ-900 Azure Fundamentals",
    issuer: "Microsoft",
    date: "07-2026",
    skills: ["Azure", "Cloud Security", "Cloud Networking"],
  },
  {
    title: "CompTIA Tech+",
    issuer: "CompTIA",
    date: "12-2025",
    skills: ["IT Fundamentals", "Networking", "Operating Systems"],
    
  },
    {
    title: "Full Stack Web Developmen",
    issuer: "DCI",
    date: "12-2022",
    skills: ["IT Fundamentals", "Networking", "Operating Systems"],
  },
];

// ==================== PROJECTS ====================
export const projectsData = {
  cybersecurity: [
    {
      title: "Game of Active Directory – AD Security Engagement",
      description: "Active Directory Offensive & Defensive Security Lab (GOAD). Simulated a complete Active Directory attack across a 2-domain, 5-host lab, achieving Domain Admin compromise through reconnaissance, credential access, privilege escalation, and lateral movement. Developed and validated 13 custom Wazuh detection rules for PowerShell abuse, Mimikatz, GodPotato, and Pass-the-Hash, then implemented targeted hardening to disrupt the attack chain.",
      technologies: ["Kali Linux", "Windows Server", "Ubuntu", "Active Directory", "Wazuh", "Nmap", "Mimikatz", "GodPotato", "MITRE ATT&CK"],
      category: "Cybersecurity",
      image: "https://plus.unsplash.com/premium_photo-1683121710572-7723bd2e235d?q=80&w=2232&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com/Wais000/Game-of-Active-Directory",
      demo: null,
      featured: true,
    },
    {
      title: "Gophish Phishing Simulation & Security Awareness",
      description: "Spear-Phishing Campaign Design & Metrics Analysis. Designed and executed a targeted spear-phishing awareness campaign for a simulated aerospace organization, validating end-to-end credential capture with a 5-user test group. Built a credential-harvesting landing page, configured SMTP email delivery, tracked click and credential-submission metrics, and delivered security recommendations to improve phishing resilience.",
      technologies: ["Gophish", "MailHog", "Docker", "QEMU", "Kali Linux", "HTML", "SMTP"],
      category: "Cybersecurity",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80",
      github: "https://github.com/Wais000/spacex-security-awareness-lab",
      demo: null,
      featured: false,
    },
    {
      title: "Process Monitoring Antivirus (EDR Simulator)",
      description: "A Python-based process monitoring antivirus for Windows that behaves like a lightweight Endpoint Detection & Response (EDR) system. Monitors running processes in real time with a live Task-Manager-style terminal UI, analyzes executables via SHA-256 hashing and VirusTotal reputation checks, and automatically reacts based on configurable security policies (kill, quarantine, log).",
      technologies: ["Python", "VirusTotal API", "Windows", "EDR", "Process Monitoring"],
      category: "Cybersecurity",
      image: "https://plus.unsplash.com/premium_photo-1674669009418-2643aa58b11b?q=80&w=2148&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com/Wais000/process-monitoring-antivirus",
      demo: null,
      featured: true,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["React", "Python", "PostgreSQL", "AWS", "Docker"],
      category: "Cybersecurity",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3",
      github: "https://github.com",
      demo: "https://demo.com",
      featured: true,
    },
  ],
  webDev: [
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["React", "Node.js", "MongoDB", "Stripe", "Redis", "Docker"],
      category: "Web Development",
      image: "https://plus.unsplash.com/premium_photo-1683288295814-84a199da83d9?q=80&w=1674&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com",
      demo: "https://demo.com",
      featured: true,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Next.js", "D3.js", "WebSocket", "PostgreSQL", "Python"],
      category: "Web Development",
      image: "https://images.unsplash.com/photo-1537884944318-390069bb8665?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com",
      demo: "https://demo.com",
      featured: false,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["React", "Node.js", "PostgreSQL", "WebRTC", "Redis"],
      category: "Web Development",
      image: "https://images.unsplash.com/photo-1730130054404-c2bd8e7038c2?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com",
      demo: "https://demo.com",
      featured: true,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Next.js", "TypeScript", "MongoDB", "Stripe", "AWS S3"],
      category: "Web Development",
      image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3",
      github: "https://github.com",
      demo: "https://demo.com",
      featured: true,
    },
  ],
  graphicDesign: [
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Figma", "Storybook", "React", "TypeScript"],
      category: "Graphic Design",
      image: "https://media.istockphoto.com/id/2160199428/de/foto/nahaufnahme-des-ui-entwicklerteams-beim-brainstorming-an-ihrem-projekt-mit-laptop-smartphone.jpg?s=1024x1024&w=is&k=20&c=4miXKFZfQ8Lyl92v0PXyuu9JKZyODUy5gJVn8IJ1JSI=",
      github: null,
      demo: "https://dribbble.com",
      featured: true,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Illustrator", "Photoshop", "InDesign", "Figma"],
      category: "Graphic Design",
      image: "https://images.unsplash.com/photo-1633533452148-a9657d2c9a5f?q=80&w=2231&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: null,
      demo: "https://behance.com",
      featured: false,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Figma", "Adobe XD", "Chart.js", "React"],
      category: "Graphic Design",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
      github: null,
      demo: "https://dribbble.com",
      featured: true,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Figma", "Principle", "Sketch", "After Effects"],
      category: "Graphic Design",
      image: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.0.3",
      github: null,
      demo: "https://behance.com",
      featured: true,
    },
  ],
  devOps: [
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Kubernetes", "Docker", "Istio", "Prometheus", "Grafana"],
      category: "DevOps",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.0.3",
      github: "https://github.com",
      demo: null,
      featured: true,
    },
    {
      title: "Coming Soon",
      description: "Details pending",
      technologies: ["Terraform", "AWS", "GitHub Actions", "Ansible"],
      category: "DevOps",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3",
      github: "https://github.com",
      demo: null,
      featured: true,
    },
  ],
};

// ==================== EXPERIENCE ====================
export const experienceData = [
  {
    title: "Software Developer",
    company: "B.I.C. GmbH",
    period: "Jan 2025 - Apr 2025",
    location: "Schleswig-Holstein, Germany",
    description: "Delivered and maintained enterprise frontend components, improving usability, performance, and cross-device responsiveness through structured development practices and Git workflows.",
    achievements: [
      "Rebuilt the frontend of a large-scale appointment booking platform for one of Germany's largest automobile clubs, improving security by minimizing external dependencies and third-party risks",
      "Achieved 98%+ responsiveness consistency across desktop, tablet, and mobile platforms",
      "Developed and optimized features for a governmental appointment kiosk system, improving usability, API integration stability, and public service workflows",
      "Reduced UI development time by 30% by creating reusable and scalable frontend components across multiple applications",
    ],
    technologies: ["Git"],
  },
  {
    title: "Software Developer (Internship)",
    company: "B.I.C. GmbH",
    period: "Sep 2024 - Dec 2024",
    location: "Schleswig-Holstein, Germany",
    description: "Implemented reusable frontend components for enterprise applications, improving UI consistency and user experience across multiple systems.",
    achievements: [
      "Built responsive layouts with 100% cross-browser compatibility by resolving rendering issues and applying modern frontend practices",
      "Supported testing, debugging, and feature refinement, identifying and resolving 50+ frontend defects to ensure stable releases",
      "Collaborated with development teams using structured workflows, Git-based version control, and code review practices",
      "Gained hands-on experience in enterprise software development, API integration, debugging, and production-oriented application maintenance",
    ],
    technologies: ["Git"],
  },
  {
    title: "Career Break – Relocation",
    company: "Personal",
    period: "Dec 2016 - Aug 2021",
    location: "Hamburg, Germany",
    description: "Resettlement, language acquisition, and cultural integration.",
    achievements: [
      "Completed German language courses up to C1 proficiency",
    ],
    technologies: [],
  },
  {
    title: "Frontend Developer",
    company: "Wasel Telecom",
    period: "Oct 2014 - Jul 2015",
    location: "",
    description: "Translated UI/UX designs into responsive web interfaces, collaborating with design teams on visual concepts and site functionality.",
    achievements: [
      "Translated UI/UX designs into responsive web interfaces using HTML, CSS, and JavaScript, improving usability and user experience",
      "Collaborated with design teams to implement visual concepts, enhance website functionality, and optimize web content",
    ],
    technologies: ["HTML", "CSS", "JavaScript"],
  },
];


// ==================== CONTACT ====================
export const contactData = {
  email: "contact.waisn@gmail.com",
  phone: "(+49) 1727 840 922",
  location: "Hamburg, Germany",
  socialLinks: {
    github: "https://github.com/Wais000",
    linkedin: "https://www.linkedin.com/in/wais-nazari/",
    xing: "https://www.xing.com/profile/Wais_Nazari/web_profiles",
    email: "mailto:contact.waisn@gmail.com",
  },
  availability: {
    status: "Available",
    type: "Remote • Contract or Full-time",
    from: "October 2026",
  },
};


// ==================== EDUCATION ====================
export const educationData = [
  {
    degree: "Cybersecurity Analyst",
    institution: "Cybersteps",
    period: "Sep 2025 – Oct 2026 · Remote",
    description: "Full-time online cybersecurity training program (1,800 hours) covering networking, cryptography, and OS security.",
    courses: [
      "Real-time threat detection and incident response using SIEM (Sentinel, Splunk), KQL, and Wireshark, mapping adversary tactics to the MITRE ATT&CK framework",
      "Built and hardened hybrid environments across Azure and Active Directory, implementing IAM/Entra ID (MFA, RBAC) and automating security via Terraform and DevSecOps pipelines",
      "Vulnerability assessments (Nessus) and risk management aligned with NIST CSF/ISO 27001, using Python and PowerShell to automate defensive workflows",
    ],
  },
  {
    degree: "Full Stack Web Developer",
    institution: "DCI Digital Career Institute",
    period: "Sep 2021 – Nov 2022 · Remote",
    description: "Intensive full-stack JavaScript training program covering frontend engineering, backend development, databases, and REST API integration.",
    courses: [
      "Built multiple full-stack projects using React/Redux, Node.js/Express, and MongoDB",
    ],
  },
];